import { useState, useRef } from "react";
import useLenis from "@/hooks/useLenis";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import MarqueeStrip from "@/components/site/MarqueeStrip";
import QuoteCalculator from "@/components/site/QuoteCalculator";
import Manifesto from "@/components/site/Manifesto";
import Services from "@/components/site/Services";
import BookingForm from "@/components/site/BookingForm";
import Footer from "@/components/site/Footer";

export default function Landing() {
  useLenis();
  const [sqft, setSqft] = useState("");
  const [addons, setAddons] = useState({ coats: false, ceilings: false, trim: false });

  const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <div className="min-h-screen bg-[#F6F6F2]">
      <Nav />
      <Hero onQuote={() => scrollTo("calculator")} />
      <MarqueeStrip />
      <QuoteCalculator sqft={sqft} setSqft={setSqft} addons={addons} setAddons={setAddons} onBook={() => scrollTo("book")} />
      <Manifesto />
      <Services />
      <BookingForm sqft={sqft} setSqft={setSqft} addons={addons} setAddons={setAddons} />
      <Footer />
    </div>
  );
}
